export const LOGIN_SUCCESS = 'LOGIN_SUCCESS'
export const PASSWORD_RESET_SUCCESS = 'PASSWORD_RESET_SUCCESS'
export const SET_USER_PROFILE = 'SET_USER_PROFILE'
export const LOGOUT = 'LOGOUT'
